import { createSlice } from "@reduxjs/toolkit";
import { fetchThresholdNotificationThunk, getThresholdChanelNotificationThunk } from "../thunk/thresholdNotificationThunk";

const thresholdNotificationSlice=createSlice({
    name:'thresholdNotification',
    initialState:{
        thresholdNotifications:[],
        thresholdNotificationChanel:{},
    },reducers:{
        
    },
    extraReducers:(builder:any)=>{
        builder.addCase(fetchThresholdNotificationThunk.fulfilled,(state:any,{payload}:any)=>{
            state.thresholdNotifications=payload
        });
        builder.addCase(getThresholdChanelNotificationThunk.fulfilled,(state:any,{payload}:any)=>{
            if(payload?.email){
                state.thresholdNotificationChanel=payload
            }else{
                state.thresholdNotificationChanel={}
            }
        })
    }
})

export default thresholdNotificationSlice.reducer